import React, { useEffect, useState, useRef } from "react";
import { useInView } from "react-intersection-observer";
import emailicon from "../assets/email-icon.png";
import locationicon from "../assets/location-icon.png";
import { languageJson } from "../StringVariable";
import { useSelector } from "react-redux";
import powerImg from "../assets/seaportLogo.png";
import moment from "moment";
import { submitGAEvent } from "src/utils/GAEvents";
moment.suppressDeprecationWarnings = true;

const Footer = () => {
  let singleUrls = useSelector((state) => state.publicUrlState);
  let userData = useSelector((state) => state.auth);
  const [fbUrl, setFbUrl] = useState(null);
  const [linkedinUrl, setLinkedinUrl] = useState(null);
  const [twitterUrl, setTwitterUrl] = useState(null);
  // const [webEmail, setWebEmail] = useState(null);
  // const [webContact, setWebContact] = useState(null);
  const [webAddress, setWebAddress] = useState(null);
  const [isDashboard, setDashboard] = useState(false);
  const [instagramLink, setInstagramLink] = useState(null);
  const [youtubeLink, setYoutubeLink] = useState(null);
  const [footer_contact_url, setFooterContactLink] = useState(null);
  const [blank_sailing_tracker, setBlankSailingTrackerLink] = useState(null);

  useEffect(() => {
    setInterval(() => {
      /******* If # is not in browser routes ************/
      //  let str = window.location.pathname;
      /******* If # is in browser routes ************/
      let str = window.location.pathname;
      let list = str?.split("/");
      list.includes("admin") ? setDashboard(false) : setDashboard(true);
    }, 500);
    return () => {
      clearInterval();
    };
  }, [window.location, userData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      singleUrls &&
      singleUrls.singleUrls &&
      singleUrls.singleUrls.length > 0
    ) {
      singleUrls.singleUrls.map((ele) => {
        switch (ele.url_id) {
          case "facebook_url":
            submitGAEvent("FACEBOOK");
            return setFbUrl(ele.url_link);
          case "linkedin_url":
            submitGAEvent("LINKEDIN");
            return setLinkedinUrl(ele.url_link);
          case "twitter_url":
            submitGAEvent("TWITTER");
            return setTwitterUrl(ele.url_link);
          // case "websiteMail":
          //   return setWebEmail(ele.url_link);
          // case "websiteContact":
          //   return setWebContact(ele.url_link);
          case "websiteAddress":
            return setWebAddress(ele.url_link);
          case "instagram":
            return setInstagramLink(ele.url_link);
          case "youtube":
            return setYoutubeLink(ele.url_link);
          case "footer_contact_url":
            return setFooterContactLink(ele.url_link);
          case "blank_sailing_tracker":
            return setBlankSailingTrackerLink(ele.url_link);
          default:
            return null;
        }
      });
    }
  }, [singleUrls.singleUrls]); // eslint-disable-line react-hooks/exhaustive-deps

  const footerRef = useRef(null);
  const webAddressRef = useRef(null);
  const copyRightRef = useRef(null);

  const { ref: setFooterInViewRef, inView: isFooterInView } = useInView({
    triggerOnce: false, // or true if you only want to trigger once
  });
  const { ref: setWebInViewRef, inView: isWebInView } = useInView({
    triggerOnce: false,
  });

  const { ref: setCopyRightViewRef, inView: isCopyRightView } = useInView({
    triggerOnce: false,
  });

  useEffect(() => {
    if (isWebInView && webAddressRef.current) {
      webAddressRef.current.classList.remove("animate__zoomIn");
      void webAddressRef.current.offsetWidth;
      webAddressRef.current.classList.add("animate__zoomIn");
    }
  }, [isWebInView]);

  useEffect(() => {
    if (isFooterInView && footerRef.current) {
      footerRef.current.classList.remove("animate__zoomIn");
      void footerRef.current.offsetWidth;
      footerRef.current.classList.add("animate__zoomIn");
    }
  }, [isFooterInView]);

  useEffect(() => {
    if (isCopyRightView && copyRightRef.current) {
      // copyRightRef.current.classList.remove('animate__zoomIn');
      // void copyRightRef.current.offsetWidth;
      // copyRightRef.current.classList.add('animate__zoomIn');
    }
  }, [isCopyRightView]);

  return (
    <React.Fragment>
      {languageJson && languageJson.footerList && isDashboard ? (
        <footer className="text-center">
          <section className="footer-sec">
            <h6
              ref={(node) => {
                setWebInViewRef(node); // intersection observer hook
                webAddressRef.current = node; // your DOM ref
              }}
              className="contact-information animate__animated"
            >
              {languageJson.footerList.contactUs}
            </h6>

            <div
              ref={(node) => {
                setFooterInViewRef(node); // intersection observer hook
                footerRef.current = node; // your DOM ref
              }}
              className="row animate__animated"
              style={{
                padding: "20px",
                marginLeft: "20px",
                alignItems: "center",
              }}
            >
              <div className="col-md-4 col-lg-4 contactusTxtDiv">
                <div className="contactusDiv-footer">
                  <p className="footer-links" style={{ marginBottom: "0px" }}>
                    <img
                      className="footer-contact-icon"
                      alt="Email Us"
                      src={emailicon}
                    />
                    <span>
                      <a
                        href={footer_contact_url}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Visit our office location (opens in a new tab)"
                      >
                        {languageJson.contact_us_footer_port}
                      </a>
                    </span>
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-lg-4">
                <div className="social-icons-container">
                  {fbUrl && (
                    <a
                      href={fbUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon facebook"
                      aria-label="Visit our Facebook profile (opens in a new tab)"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  )}
                  {twitterUrl && (
                    <a
                      href={twitterUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon twitter"
                      aria-label="Visit our Twitter profile (opens in a new tab)"
                    >
                      <i class="fa-brands fa-x-twitter"></i>{" "}
                    </a>
                  )}
                  {instagramLink && (
                    <a
                      href={instagramLink}
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon instagram"
                      aria-label="Visit our Instagram profile (opens in a new tab)"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  )}
                  {linkedinUrl && (
                    <a
                      href={linkedinUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon linkedin"
                      aria-label="Visit our LinkedIn profile (opens in a new tab)"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  )}
                  {youtubeLink && (
                    <a
                      href={youtubeLink}
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon youtube"
                      aria-label="Visit our YouTube channel (opens in a new tab)"
                    >
                      <i className="fab fa-youtube"></i>
                    </a>
                  )}
                </div>
              </div>

              {/* <div>
                  {fbUrl !== null && (
                    <a href={fbUrl} target="_blank" rel="noreferrer">
                      {" "}
                      <img
                        className="p-3"
                        src={facebookicon}
                        alt="Go to Facebook"
                      />
                    </a>
                  )}
                  {linkedinUrl !== null && (
                    <a href={linkedinUrl} target="_blank" rel="noreferrer">
                      {" "}
                      <img
                        className="p-3"
                        src={linkedinicon}
                        alt="Go to LinkedIn"
                      />{" "}
                    </a>
                  )}
                  {twitterUrl !== null && (
                    <a href={twitterUrl} target="_blank" rel="noreferrer">
                      {" "}
                      <img
                        className="p-3"
                        src={twittericon}
                        alt="Go to Twitter"
                      />
                    </a>
                  )}
                  {instagramLink !== null && (
                    <a href={instagramLink} target="_blank" rel="noreferrer">
                      {" "}
                      <img
                        className="p-3"
                        src={instagramIcon}
                        alt="Go to Instagram"
                      />
                    </a>
                  )}
                  {youtubeLink !== null && (
                    <a href={youtubeLink} target="_blank" rel="noreferrer">
                      {" "}
                      <img
                        className="p-3"
                        src={youtubeIcon}
                        alt="Go to youtube channel"
                      />
                    </a>
                  )}
                </div> */}

              <div className="col-md-4 col-lg-4 addressTxtDiv ">
                <div className="portlink-div">
                  <p className="footer-links" style={{ marginBottom: "0px" }}>
                    <img
                      className="footer-contact-icon"
                      alt="Our Office Location"
                      src={locationicon}
                    />
                    <span className="addressTxt">
                      <a
                        href={`https://maps.google.com/?q=${webAddress}`}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Visit our office location (opens in a new tab)"
                      >
                        {webAddress}
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <p
            ref={(node) => {
              setCopyRightViewRef(node); // intersection observer hook
              copyRightRef.current = node; // your DOM ref
            }}
            className="text-center text-white pb-3 policy-bg pt-3 mb-0 animate__animated"
            style={{ background: "white" }}
          >
            <span style={{ color: "black" }}>
              {" "}
              {languageJson.footerList.CopyrightTxt} {moment().year()} -{" "}
              {moment().year() + 1}&nbsp;&nbsp;|&nbsp;&nbsp;{" "}
              {languageJson.app_name_txt}{" "}
              <img
                className="powerImgFooterDiv"
                alt="Powerd By Seaport"
                src={powerImg}
              ></img>{" "}
              &nbsp;&nbsp;| &nbsp;&nbsp;
              {languageJson.footerList.allrightsreserved} &nbsp;&nbsp;{" "}
            </span>
            {/* <b className="versionTxtDiv">Version-1.0.0</b> */}
          </p>
        </footer>
      ) : null}
    </React.Fragment>
  );
};

export default Footer;
